import React, { memo } from "react";

import GridColumn from "../../components/grid/GridColumn";
import GridHeaderCell from "../../components/grid/GridHeaderCell";
import Checkbox from "../inputform/Checkbox";

interface GridHeaderRowProps<T> {
    columns: GridColumn<T>[];
    sortField: string;
    bulkEdit?: boolean;
    bulkAll: boolean;
    blockSort?: boolean;
    onClick?: (column: GridColumn<T>) => void;
    onSelectAllChanged?: (value: boolean) => void;
}

class GridHeaderRow<T> extends React.Component<GridHeaderRowProps<T>> {
    render(): React.ReactNode {
        return (
            <tr>
                {this.props.bulkEdit ? (
                    <th className="grid-header-cell bulk-select">
                        <Checkbox
                            value={this.props.bulkAll}
                            onChange={this.props.onSelectAllChanged}
                        />
                    </th>
                ) : null}
                {this.props.columns.map((column, index) => (
                    <GridHeaderCell
                        key={index}
                        index={index}
                        column={column}
                        sortField={this.props.sortField}
                        blockSort={this.props.blockSort}
                        onClick={this.props?.onClick}
                    />
                ))}
            </tr>
        );
    }
}

export default memo(GridHeaderRow);
